import React, { useEffect, useState } from 'react';
import './Home.css';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BounceLoader from 'react-spinners/BeatLoader';
import ScaleLoader from 'react-spinners/ScaleLoader';


const Home = ({ darkmodeClass }) => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [sortBy, setSortBy] = useState('sort by');
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 767);
  const [notResultFound, setNotResultFound] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isImgloading, setIsImgLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let categoryFilter = '';

        //Sets search to default when there is no search term
        if (!search) {
          setFilter('all');
          setSortBy('sort by');
        }

        switch (filter) {
          case 'all':
            categoryFilter = '';
            break;
          case 'photo':
          case 'illustration':
          case 'vector':
          case 'computer':
          case 'iphone':
          case 'nature':
          case 'background':
          case 'entertainment':
          case 'christmas':
          case 'sky':
          case 'food':
          case 'snow':
          case 'love':
          case 'trending':
          case 'sports':
          case 'technology':
          case 'cars':
          case 'world':
          case 'appliances':
          case 'musical instrument':
          case 'fashion':
          case 'stationery':
          case 'landscape':
          case 'season':
          case 'ocean':
          case 'waterfall':
          case 'earth':
          case 'people':
          case 'lifestyle':
          case 'festival':
          case 'party':
          case 'luxury':
            categoryFilter = `&q=${filter}`;
            break;
          default:
            categoryFilter = `&category=${filter}`;
        }

        const orderParam = sortBy !== 'sort by' ? `&order=${sortBy}` : '';

        const response = await fetch(`https://pixabay.com/api/?key=32203192-efce0f01a2d536067e1bb0d0c&q=${search}&image_type=photo&pretty=true${categoryFilter}${orderParam}`);
        const result = await response.json();

        setData(result.hits);
        setNotResultFound(result.hits.length === 0);
        setError(" ");
      } catch (error) {
        setError('Error fetching data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        // Handle search when Enter key is pressed
        fetchData();
      }
    };

    // Add event listener for key press
    document.addEventListener('keypress', handleKeyPress);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener('keypress', handleKeyPress);
    };
  }, [search, filter, sortBy]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const clearFilters = () => {
    setSearch('');
    setFilter('all');
    setSortBy('sort by');
  };

  const handleSortChange = (value) => {
    setSortBy(value);
  };

  const handleFilterClick = (category) => {
    setSearch(category);
    setFilter(category);
  };

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setSearch(selectedValue);
    setFilter(selectedValue);
  };

  const handleAllButtonClick = () => {
    setSearch('');
    setFilter('all');
  };

  const handleImageClick = (imageUrl) => {
    // Add no-scroll class to disable scrolling
    document.body.classList.add('no-scroll');

    // Use SweetAlert2 modal to display the image
    Swal.fire({
      imageUrl: imageUrl,
      imageAlt: 'Overlay Image',
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        container: 'overlay-container',
        closeButton: 'custom-close-button',
        confirmButton: 'custom-confirm-button',
      },
      imageWidth: '100%',
      imageHeight: '100%',
    }).then(() => {
      // Remove the no-scroll class when the modal is closed
      document.body.classList.remove('no-scroll');
    });
  };

  const handleDownloadClick = async (imageUrl) => {
    setIsImgLoading(true);
    try {
      // Fetch the image data
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Create a Blob from the image data
      const blobUrl = URL.createObjectURL(blob);

      // Use SweetAlert2 modal to display the image and buttons
      Swal.fire({
        imageUrl: blobUrl,
        imageAlt: 'Overlay Image',
        showCloseButton: true,
        showConfirmButton: false,
        customClass: {
          container: 'overlay-container',
          closeButton: 'custom-close-button',
        },
        imageWidth: '100%',
        imageHeight: '100%',
        html: `
          <div>
            <button class="swal2-confirm swal2-styled" onclick="handleDownload('${blobUrl}')">
              Download
            </button>
            <button class="swal2-cancel swal2-styled" onclick="handleClose()">
              Close
            </button>
          </div>
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          toast.success('Image downloaded successfully!', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        document.body.classList.remove('no-scroll');
      });
    } catch (error) {
      toast.error('Error downloading image. Please try again later.');
    } finally {
      setIsImgLoading(false);
    }
  };


  // Function to handle the close button click
  window.handleClose = () => {
    // Close the SweetAlert2 modal
    Swal.close();

    // Remove the no-scroll class to enable scrolling
    document.body.classList.remove('no-scroll');
  };


  // Function to handle the download button click
  window.handleDownload = (blobUrl) => {
    // Create a link element
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'downloaded-image';

    // Simulate a click on the link to trigger the download
    link.click();

    // Close the SweetAlert2 modal
    Swal.close();

    // Remove the no-scroll class to enable scrolling
    document.body.classList.remove('no-scroll');
  };

  return (
    <div className={`home ${isImgloading ? 'loading-opacity' : ''}`}>
      <div className={`input-container ${darkmodeClass}`}>
        <h1 className={`${darkmodeClass}`}>Stunning royalty-free images & royalty-free stock</h1>
        <input className={`input ${darkmodeClass}`} placeholder="Search for Images" value={search === 'default' ? '' : search} onChange={(e) => setSearch(e.target.value)} />
        {loading && (<div className={`sweet-loading ${loading ? 'loading-opacity' : ''}`}>
          <BounceLoader color='#36d7b7' size={50} loading={loading} />
        </div>)}
        {error && (
          <div className={`error-message-container ${darkmodeClass}`}>
            <p className="error-message">{error}</p>
          </div>
        )}

        {notResultFound && (
          <div className={`no-results-message ${darkmodeClass}`}>
            <img className='emojinoresults' src='https://images.emojiterra.com/google/android-10/512px/1f623.png' alt='No results found emoji' />
            <p className="error-message">No results found. Please try a different search term.</p>
          </div>
        )}

      </div>
      {!loading && (
        !error || !notResultFound && (
          <>
            <div className={`filter-options ${darkmodeClass}`}>
              {isSmallScreen ? (
                ['all', 'trending', 'sports', 'computer', 'iphone'].map((category) => (
                  <button key={category} className={`${darkmodeClass} ${filter === category ? 'active' : ''}`} onClick={() => handleFilterClick(category)}>{category}</button>
                ))
              ) : (
                <>
                  <button key="all" className={`${darkmodeClass} ${filter === 'all' ? 'active' : ''}`} value="all" onClick={handleAllButtonClick}>All</button>
                  {['trending', 'sports', 'computer', 'iphone', 'love', 'nature', 'background', 'entertainment', 'sky', 'food', 'technology', 'cars', 'world'].map((category) => (
                    <button key={category} className={`${darkmodeClass} ${filter === category ? 'active' : ''}`} onClick={() => handleFilterClick(category)}>{category}</button>
                  ))}
                </>
              )}

              <select className={`filter-select ${darkmodeClass} ${filter !== 'all' ? 'active' : ''}`} value={filter} onChange={handleSelectChange}>
                <option className={`${darkmodeClass}`} value="all">All Filters</option>
                {['trending', 'sports', 'computer', 'iphone', 'love', 'nature', 'background', 'entertainment', 'sky', 'food', 'technology', 'cars', 'world', 'appliances', 'musical instrument', 'fashion', 'stationery', 'landscape', 'season', 'ocean', 'waterfall', 'earth', 'people', 'lifestyle', 'festival', 'party', 'luxury']
                  .sort()
                  .map((category) => (
                    <option className={`${darkmodeClass}`} key={category} value={category}>{category}</option>
                  ))}
              </select>

              <select className={`sort-select ${darkmodeClass} ${sortBy !== 'sort by' ? 'active' : ''}`} value={sortBy} onChange={(e) => handleSortChange(e.target.value)}>
                <option className={`${darkmodeClass}`} value="sort by">Sort By</option>
                <option className={`${darkmodeClass}`} value="popular">Popular</option>
                <option className={`${darkmodeClass}`} value="latest">Latest</option>
              </select>
              <button className={`clear ${darkmodeClass}`} onClick={clearFilters}>Clear Filters</button>
            </div>


            <section className={`sec ${darkmodeClass}`}>
              <div className={`container ${darkmodeClass}`}>
                {isImgloading && (
                  <div className="img-loading">
                    <ScaleLoader color='#36d7b7' size={1000} />
                  </div>
                )}
                {data && (
                  data.map((items) => (
                    <div key={items.id} className={`image-container ${darkmodeClass}`}>
                      <img src={items.webformatURL} alt="" height={items.webformatHeight} width={items.webformatWidth} onClick={() => handleImageClick(items.webformatURL)} />
                      <div className={`image-name ${darkmodeClass}`}>{items.tags}</div>
                      {!isImgloading && (<button className={`download-button ${darkmodeClass}`} onClick={() => handleDownloadClick(items.webformatURL)}>Download</button>
                      )
                      } </div>
                  ))
                )}
              </div>
            </section>

          </>

        )
      )}  <ToastContainer />

    </div>
  );
};

export default Home;
